import * as Sentry from '@sentry/vue';

export function useSentry() {
  return Sentry;
}
